<template>
  <Layout>

    <div class="col-12">
      <div class="page-title-box">
        <h4 class="page-title">Dashboard</h4>
      </div>
    </div>

    <div class="row">
      <div v-for="widget in widgetData" :key="widget.number" class="col-md-6 col-xl-3">
        <div class="widget-rounded-circle card-box">
          <div class="row">
            <div class="col-6">
              <div
                      :class=" `avatar-lg rounded-circle bg-soft-${widget.color} border-${widget.color} border`"
              >
                <i :class="`${widget.icon} font-22 avatar-title text-${widget.color}`"></i>
              </div>
            </div>
            <div class="col-6">
              <div class="text-right">
                <h3 class="text-dark mt-1">
                  <span>
                    {{widget.subIcon}}<countTo :end-val="widget.number" :duration="3000"></countTo>
                  </span>
                </h3>
                <p class="text-muted mb-1 text-truncate">{{widget.title}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- end card-box -->
      </div>
      <!-- end col -->
    </div>

    <div class="row">
      <div v-for="widget in walletData" :key="widget.number" class="col-md-6 col-xl-3">
        <div class="widget-rounded-circle card-box">
          <div class="row">
            <div class="col-6">
              <div
                      :class=" `avatar-lg rounded-circle bg-soft-${widget.color} border-${widget.color} border`"
              >
                <i :class="`${widget.icon} font-22 avatar-title text-${widget.color}`"></i>
              </div>
            </div>
            <div class="col-6">
              <div class="text-right">
                <h3 class="text-dark mt-1">
                  <span>
                    {{widget.subIcon}}<countTo :end-val="widget.number" :duration="3000"></countTo>
                  </span>
                </h3>
                <p class="text-muted mb-1 text-truncate">{{widget.title}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- end card-box -->
      </div>
      <!-- end col -->
    </div>

    <div class="row">
      <div class="col-xl-12">
        <Portlet :headertitle="headerTitle1">
          <div class="card-body mt-0">
            <!-- Lifetime Sales area chart-->
            <BarChart
                    ref="monthChart"
                    :height="350"
                    :date="dashBoard.date.toISOString().split('T')[0]"/>
            <!-- end Lifetime Sales chart-->
          </div>
          <!-- end row -->
        </Portlet>
      </div>
    </div>


    <div class="row">

      <div class="col-xl-4">
        <Portlet :headertitle="headerTitle3">
          <div class="card-body pt-0">
            <!-- Total users pie chart-->
            <apexchart
                    ref="saleRatioChart"
                    height="265"
                    type="pie"
                    :series="productPieChart.series"
                    :options="productPieChart.chartOptions"
            ></apexchart>
            <!-- end Total users pie chart-->
            <!-- end row -->
          </div>
        </Portlet>
      </div>
      <!-- Table -->
      <div class="col-xl-8">
        <Portlet :headertitle="topSellingTitle">
          <div class="card-body pt-0">
            <div class="table-responsive mb-0">
              <table class="table table-hover table-centered mb-0">
                <thead>
                <tr>
                  <th>Product Id</th>
                  <th>Product Name</th>
                  <th>Quantity</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="each in topSellingData" :key="each.id">
                  <td>{{ each.id }}</td>
                  <td>{{ each.name }}</td>
                  <td>{{ each.quantity }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Portlet>
      </div>
    </div>

    <div class="row">
      <!-- Table -->
      <div class="col-xl-12">
        <Portlet :headertitle="recentOrderTitle">
          <div class="card-body pt-0">
            <div class="table-responsive mb-0">
              <table class="table table-hover table-centered mb-0">
                <thead>
                <tr>
                  <th>Order Id</th>
                  <th>Company Name</th>
                  <th>Ref No.</th>
                  <th>Status</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="each in lastOrders" :key="each.id">
                  <td>{{ each.id }}</td>
                  <td>{{ each.company.name }}</td>
                  <td>{{ each.ref_no }}</td>
                  <td>{{ each.status }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Portlet>
      </div>
    </div>

  </Layout>

</template>

<script>
  import countTo from 'vue-count-to'

  import appConfig from '@src/app.config'
  import Layout from '@layouts/main'

  import Portlet from '@src/components/portlet'
  import BarChart from '@src/components/chart/BarChart'

  import { dashBoardMethods } from '@state/helpers'

  import {
    lifetimeSalesAreaChart,
    incomeAmountsLineChart,
    productPieChart,
  } from './dashboard-data'

  /**
   * Dashboard component
   */
  export default {
    page: {
      title: 'Dashboard',
      meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { countTo, Layout, Portlet, BarChart },
    data() {
      return {
        topSellingData: [],
        lastOrders: [],
        widgetData: [],
        walletData: [],
        lifetimeSalesAreaChart: lifetimeSalesAreaChart,
        incomeAmountsLineChart: incomeAmountsLineChart,
        productPieChart: productPieChart,
        title: 'Dashboard',
        headerTitle1: 'Last month vs Current month',
        headerTitle2: 'Income Amounts',
        headerTitle3: 'Total Sale',
        topSellingTitle: 'Top Selling Products',
        recentOrderTitle: 'Recent orders',
        items: [
          {
            text: '99Gift',
            href: '/',
          },
          {
            text: 'Dashboard',
            active: true,
          },
        ],
        dashBoard: {
          date: new Date(),
          limit:{min: '20/08/2020', max: new Date().toISOString().split('T')[0]},
        },
      }
    },

    mounted(){
      this.fetchWidgetData()
      this.fetchGraphData()
      this.fetchTopSellingData()
      this.fetchRecentOrders()
      this.fetchWalletData()
    },

    methods: {

      ...dashBoardMethods,


      refreshDashBoard(){
        this.fetchWidgetData()
        this.fetchGraphData()
        this.fetchTopSellingData()
        this.fetchRecentOrders()
        this.fetchWalletData()
      },

      async fetchWidgetData(){

        try{

          const { success, message, data: { result } } = await this.widgets(this.dashBoard.date.toISOString().split('T')[0])

          if(!success) throw new Error(message)

          this.widgetData = result;
        }
        catch (e){
          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }
      },

      async fetchWalletData(){

        try{

          const { success, message, data: { result } } = await this.walletWidgets(this.dashBoard.date.toISOString().split('T')[0])

          if(!success) throw new Error(message)

          this.walletData = result;
        }
        catch (e){
          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }
      },

      async fetchGraphData(){

        try{

          const { success, message, data: { result } } = await this.graphs(this.dashBoard.date.toISOString().split('T')[0])

          if(!success) throw new Error(message)

          this.productPieChart.series = result.series || []
          this.productPieChart.chartOptions.labels = result.labels || []

          this.$refs.saleRatioChart.refresh()
        }
        catch (e){
          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }
      },

      async fetchTopSellingData(){

        try{

          const { success, message, data: { result } } = await this.topSelling(this.dashBoard.date.toISOString().split('T')[0])

          if(!success) throw new Error(message)

          this.topSellingData = result;

        }
        catch (e){
          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }
      },

      async fetchRecentOrders(){

        try{

          const { success, message, data: { result } } = await this.recentOrders(this.dashBoard.date.toISOString().split('T')[0])

          if(!success) throw new Error(message)

          this.lastOrders = result.data;

        }
        catch (e){
          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }
      },

    }
  }
</script>